import { StyleFn } from '..'

export const ButtonGroup: StyleFn = (theme) => {
  const {
    color,
    size: { spacing },
  } = theme
  const borderColor = color.type === 'light' ? color.palette.primaryblue['60'] : color.palette.white
  const focusAfter = {
    content: '""',
    position: 'absolute',
    top: -2,
    left: 0,
    right: 0,
    bottom: -2,
    borderRadius: 0,
    border: `2px solid ${color.getModalValues(color.border.focus)}`,
  }
  const focusFirst = {
    borderTopLeftRadius: 3,
    borderBottomLeftRadius: 3,
    left: -2,
  }
  const focusLast = {
    right: -2,
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
  }

  return {
    root: {
      display: 'inline-flex',
      boxSizing: 'border-box',
      borderRadius: 3,
      border: `1px solid ${borderColor}`,
      '& button': {
        border: 0,
        borderRadius: 0,
        position: 'relative',
        '&:before': {
          position: 'absolute',
          zIndex: 1,
          content: "''",
          top: spacing[8],
          bottom: spacing[8],
          left: 0,
          borderLeft: `1px solid ${borderColor}`,
        },
        '&:focus': {
          border: '0 !important',
        },
        '&:focus-visible:after': focusAfter,
        '&:first-child': {
          '&:before': {
            display: 'none',
          },
          borderTopLeftRadius: 3,
          borderBottomLeftRadius: 3,
          '&:focus-visible:after': focusFirst,
        },
        '&:last-child': {
          borderTopRightRadius: 3,
          borderBottomRightRadius: 3,
          '&:focus-visible:after': focusLast,
        },
      },
    },
  }
}
